// utils/deviceInfo.js 或直接写在组件 methods / created 中

export default function getDeviceInfo() {
  const ua = navigator.userAgent;
  const device = {
    // 浏览器信息
    browser: '',
    browserVersion: '',
    // 操作系统
    os: '',
    // 设备类型
    deviceType: '', // mobile / tablet / desktop
    // 屏幕信息
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
    // 是否是移动端
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    // 其他
    language: navigator.language || navigator.browserLanguage,
    platform: navigator.platform, // 如 Win32, MacIntel, Linux x86_64 等
  };

  // 判断操作系统
  if (/Windows/.test(ua)) device.os = 'Windows';
  else if (/Mac OS X/.test(ua)) device.os = 'macOS';
  else if (/Linux/.test(ua)) device.os = 'Linux';
  else if (/Android/.test(ua)) device.os = 'Android';
  else if (/iPhone|iPad|iPod/.test(ua)) device.os = 'iOS';
  else device.os = 'Unknown';

  // 判断浏览器（简单版）
  if (ua.indexOf('Edg/') > -1) {
    device.browser = 'Edge';
    device.browserVersion = ua.split('Edg/')[1].split(' ')[0];
  } else if (ua.indexOf('Chrome') > -1 && ua.indexOf('Edg/') === -1) {
    device.browser = 'Chrome';
    device.browserVersion = ua.split('Chrome/')[1].split(' ')[0];
  } else if (ua.indexOf('Firefox') > -1) {
    device.browser = 'Firefox';
    device.browserVersion = ua.split('Firefox/')[1].split(' ')[0];
  } else if (ua.indexOf('Safari') > -1 && ua.indexOf('Chrome') === -1) {
    device.browser = 'Safari';
    const safariMatch = ua.match(/Version\/([\d.]+)/);
    device.browserVersion = safariMatch ? safariMatch[1] : 'Unknown';
  } else if (ua.indexOf('Trident') > -1 || ua.indexOf('MSIE') > -1) {
    device.browser = 'IE';
    device.browserVersion = 'Legacy';
  } else {
    device.browser = 'Unknown';
    device.browserVersion = 'Unknown';
  }

  // 判断设备类型（简化逻辑）
  const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  const isTablet = /iPad|Android(?!.*Mobile)|Tablet/i.test(ua);

  device.isMobile = isMobile && !isTablet;
  device.isTablet = isTablet;
  device.isDesktop = !isMobile;

  device.deviceType = device.isTablet ? 'tablet' : device.isMobile ? 'mobile' : 'desktop';

  return device;
}